/**
 * Validates and rewrites the input value to allow only numeric values up to 10 digits.
 */

export const validateNumericInput = (
  value: string,
  charLimit: number,
): string => {
  // Remove all non-numeric characters and limit to 10 digits
  return value.replace(/[^0-9]/g, "").substring(0, charLimit);
};

export const validateStringInput = (
  value: string,
  charLimit: number,
): string => {
  return value.substring(0, charLimit);
};
